export const BACKGROUND_COLOR = {
    BLUE_IMAGE: 'blue_image',
    BLANK: 'blank',
    ONBOARDING_GUIDE: 'onboarding_guide'
}
